export const HandleIcon = ({ orientation, minimal }) => {
  if (minimal) {
    return orientation === 'horizontal' ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="20"
        viewBox="0 -2 16 16"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.33333 4L4 4L4 12L5.33333 12L5.33333 4ZM8.66659 4L8.66659 12L7.33325 12L7.33325 4L8.66659 4ZM12.0001 4L12.0001 12L10.6667 12L10.6667 4L12.0001 4Z"
          fill="white"
        />
      </svg>
    ) : (
      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="12" height="1" />
        <rect y="3" width="12" height="1" />
        <rect y="6" width="12" height="1" />
      </svg>
    );
  }
  return orientation === 'horizontal' ? (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="7.5" y="0.5" width="12" height="1" transform="rotate(90 7.5 0.5)" />
      <rect x="4.5" y="0.5" width="12" height="1" transform="rotate(90 4.5 0.5)" />
      <rect x="1.5" y="0.5" width="12" height="1" transform="rotate(90 1.5 0.5)" />
    </svg>
  ) : (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="12" height="1" />
      <rect y="3" width="12" height="1" />
      <rect y="6" width="12" height="1" />
    </svg>
  );
};
